import { focusHalo, HapticSurface, panelMotion, press } from "@pax/ui";

const guestButton = `relative mt-3 flex h-12 w-full items-center justify-center rounded-full text-sm font-medium hover:bg-foreground/5 disabled:opacity-50 ${panelMotion} ${press} ${focusHalo}`;

/**
 * The other way in, under the providers wherever a guest can go on: below a rule, because
 * starting without an account is a different kind of answer.
 */
export function GuestOption({
  pending,
  onPlay,
  className = "mt-7",
}: {
  pending: boolean;
  onPlay: () => void;
  /** Its distance from the providers, which a dialog's own spacing already gives. */
  className?: string;
}) {
  return (
    <div className={className}>
      <div className="flex items-center gap-4 text-xs text-muted-foreground">
        <span className="h-px flex-1 bg-border" />
        or
        <span className="h-px flex-1 bg-border" />
      </div>
      <button type="button" disabled={pending} onClick={onPlay} className={guestButton}>
        Play as a guest
        <HapticSurface />
      </button>
    </div>
  );
}
